<template>
  <component
    :is="componentName"
    ref="autocomplete"
    v-bind="$attrs"
    v-on="$listeners"
  />
</template>

<script>
import { openApiMixin } from './BAutocompleteCommon/mixins'


const TYPES = {
  PARTICIPANTS: 'participants',
  USERS: 'users',
}

const getComponent = ({ $type }) => {
  switch ($type) {
    case TYPES.PARTICIPANTS:
      return () => import(
        /* webpackChunkName: "b-async-autocomplete-common.participants" */
        './BAsyncAutocompleteCommon/BAutocompleteParticipants.vue'
      )

    case TYPES.USERS:
      return () => import(
        /* webpackChunkName: "b-async-autocomplete-common.participants" */
        './BAsyncAutocompleteCommon/BAutocompleteUsers.vue'
      )

    default:
      return process.env.NODE_ENV === 'development'
        && {
          functional: true,
          render: (h) => h(
            'div',
            {
              class: 'red white--text align-center justify-center',
              style: 'height: 100%; display: flex;',
            },
            `Type "${$type}" for <b-async-autocomplete-common /> not supported`,
          ),
        }
  }
}

export default {
  name: 'BAsyncAutocompleteCommon',
  mixins: [
    openApiMixin,
  ],
  inheritAttrs: false,
  props: {
    $type: {
      type: String,
      required: true,
      validator: (prop) => Object.values(TYPES).includes(prop),
    },
  },
  computed: {
    componentName() {
      return getComponent(this)
    },
  },
}
</script>
